import { Box, SxProps, Typography, Theme } from "@mui/material";
import ExportModal from "components/ExportModal";
import Flex from "components/Flex";
import { useState } from "react";
import { useAppSelector } from "redux/hooks";
import { selectCaseClaimantName } from "redux/slices/case/";
import ExportsCenter from "./ExportCenter";
import ExportChronologyModal from "./ExportChronologyModal";
import { useExportFunctions } from "helpers/hooks/useExportFunctions";

export interface CaseExportsProps {
  sx: SxProps<Theme>;
  caseId: number;
}

const CaseExports = (props: CaseExportsProps) => {
  const { sx, caseId } = props;
  const [exportCaseProfileModalOpen, setExportCaseProfileModalOpen] = useState(false);
  const [exportCaseChronologyModalOpen, setExportCaseChronologyModalOpen] = useState(false);
  const claimantName = useAppSelector(selectCaseClaimantName);
  const { doChronologyExport } = useExportFunctions();

  const exportBody = (
    <Flex>
      <Typography variant="h6">Profile Export Settings</Typography>
      <Typography>{claimantName}</Typography>
    </Flex>
  );

  return (
    <Box sx={sx}>
      <ExportsCenter
        setExportCaseProfileModalOpen={setExportCaseProfileModalOpen}
        setExportCaseChronologyModalOpen={setExportCaseChronologyModalOpen}
        caseId={caseId}
      />
      {exportCaseProfileModalOpen && (
        <ExportModal
          body={exportBody}
          open={exportCaseProfileModalOpen}
          setOpen={setExportCaseProfileModalOpen}
          caseId={caseId}
        />
      )}

      <ExportChronologyModal
        caseId={caseId}
        open={exportCaseChronologyModalOpen}
        close={() => setExportCaseChronologyModalOpen(false)}
        doExport={doChronologyExport}
        claimant={claimantName}
      />
    </Box>
  );
};

export default CaseExports;
